<template>
  <!-- <div class="generic" > -->
    <v-container  color="red">
      <v-layout row wrap color="red">
        <v-layout column>
        <v-flex :xs12="!secondDialogEnabled" :xs7="secondDialogEnabled" v-if="!arrayEditTable || (arrayEditTable && arrayEditSelector > 0)">
    <v-card text style="min-height:100%; padding: 20px; width:100%; height: 100%; border: 1px solid;" >
      
      <v-card-actions >
        <h2>{{dialogTitle}}</h2>
        <v-spacer></v-spacer>
        <v-btn v-if="measure" color="green darken-1" text @click.native="dialogMeasure(editedItem)">Remote Scale<v-icon style="padding-left: 10px;" left color="green">mdi-remote</v-icon></v-btn>
        <v-btn v-if="remote" color="green darken-1" text @click.native="dialogRemote(editedItem)">Remote<v-icon style="padding-left: 10px;" left color="green">mdi-remote</v-icon></v-btn>
        <v-btn v-if="rfid" color="green darken-1" text @click.native="dialogRFID(editedItem)">RFID</v-btn>
        <div v-if="dialogFooter">
        <v-btn color="blue darken-1" text @click.native="cancel">Cancel <v-icon style="padding-left: 12px;" left color="red">mdi-cancel</v-icon></v-btn>
        <v-btn color="blue darken-1" text @click.native="save">Save <v-icon style="padding-left: 12px;" left color="green">mdi-content-save</v-icon></v-btn>
        </div>
      </v-card-actions>

      <v-card-text style="height: 100%; padding: 0px;">
        <v-container  style="height: 100%; padding: 3px;">
          <slot name="top-dialog"></slot>
          <div v-if="readOnlyItems">
          <ReadOnlyItems :editables="editables" :editedItem="editedItem" :headers="headers" />
          <v-divider />
          </div>
          <h2 style="padding: 0px; padding-top: 1rem">{{'editableItems' | phrasemap}}</h2>
          <v-layout wrap style="margin: 0px; padding: 0px;">
            <v-flex v-for="eitem in editables" v-show="eitem.readonly != true && eitem.code != true && !(editedItem._fields && editedItem._fields.includes(eitem.name))" :key="eitem.name" xs12 sm6 md4 lg3 xl2 @focus="onFocus(eitem)" style="padding-right: 3px;">
              <v-layout column  v-if="eitem.measure" id="measure-div" style="padding: 0rem;" >
                <Measure :onFocus="onFocus" :eitem="eitem" :item="editedItem[eitem.name] ? editedItem[eitem.name] : null"  :save="save"/>
              </v-layout>
              <div  v-else-if="eitem.list">
                <v-select @focus="onFocus(eitem)" @keyup.enter="save"
                  :error-messages="errorObj ? errorObj[eitem.name]: ''" 
                  :label="eitem.header.replace('<br>',' ')" 
                  v-model="editedItem[eitem.name]" 
                  :items="eitem.listItems" 
                  :multiple="eitem.multiple || false"
                >
                </v-select>
              </div>
              
              <div  v-else-if="eitem.objectlist" @focus="onFocus(eitem)">
                <AutoListObjects @focus="onFocus(eitem)" :eitem="eitem" :editedItem="editedItem"     :emsg="errorObj[eitem.name]" :save="save" :asearch="asearch" :onSelect="() =>{}" />
              </div>
              
              <v-textarea  outlined @focus="onFocus(eitem)" v-else-if="eitem.textarea"  :error-messages="errorObj ? errorObj[eitem.name] : ''" v-on:keyup.enter="save" v-model="editedItem[eitem.name]" :label="eitem.header.replace('<br>',' ')"></v-textarea>
              <div v-else-if="eitem.picker" max-width="200px">
                <v-menu @focus="onFocus(eitem)"
                  ref="pickerdialog"
                  :close-on-content-click="true"
                  v-model="modalpicker"
                  offset-y
                  transition="scale-transition"
                  :return-value.sync="picker"
                  lazy
                >
                <v-text-field @focus="onFocus(eitem)" slot="activator" v-model="editedItem[eitem.name]" :label="eitem.header.replace('<br>',' ')" readonly></v-text-field>
                <component :is="eitem.component"  :prop="eitem.prop" v-model="picker" > 
                </component>
                </v-menu>
              </div>
              <div v-else-if="eitem.datetimepicker && !arrayEditTable">
                <VueCtkDateTimePicker 
                  :error-messages="errorObj ? errorObj[eitem.name] : ''" 
                  v-model="editedItem[eitem.name]" 
                  no-value-to-custom-elem
                  output-format="llll"
                  :dark="dark"
                  minute-interval="5"
                >
                <v-text-field 
                  :label="eitem.header.replace('<br>',' ')" 
                  :value="editedItem[eitem.name]" 
                  :error-messages="errorObj ? errorObj[eitem.name] : ''"
                  clearable
                  @click:clear='editedItem[eitem.name]=null'
                ></v-text-field>
                  
                </VueCtkDateTimePicker>
              </div>

              <div v-else-if="eitem.array || false">
                <v-text-field  @focus="onFocus(eitem)"   prepend-inner-icon="edit" @keyup.enter="save" :readonly="eitem.array || false" :label="eitem.header.replace('<br>',' ')" :prop="eitem.prop">
                </v-text-field>
              </div>
              <div v-else-if="eitem.fileDND">
                <v-text-field slot="activator" @focus="onFocus(eitem)" v-model="editedItem[eitem.name]" :label="eitem.header.replace('<br>',' ')"></v-text-field>
                <singleDND :rec=editedItem :name=eitem.name :dir=table
                  :fileCallback="DNDFileCallback">
                </singleDND>
              </div>
              <v-text-field  @focus="onFocus(eitem)"
                :append-icon="remote && focusedItem.name === eitem.name ? 'mdi-barcode-scan' : undefined"
                @click:append="dialogRemote(eitem)"
                v-else 
                :error-messages="errorObj ? errorObj[eitem.name] : ''" 
                v-model="editedItem[eitem.name]"  
                :label="eitem.header.replace('<br>',' ')" 
                :readonly="eitem.readonly || false" 
                @keyup.enter="save"
              ></v-text-field>
            </v-flex>
          </v-layout>
        
        <div v-if="isArray" > 
          <h4>{{ arrayTitle }}</h4>
          <!-- <transition name="modal">
            <div class="modal-mask">
          <div class="modal-wrapper">
            <div class="modal-container">
            <div>
          <v-divider /> -->
          <server-table-component 
            simple
            editable
            :dialog="isArray"
            :title="arrayTitle"
            :schemaProp="arrayHeaders"
            :rowProp="arrayRows"
            :editables="arrayEditables"
            :schema="arraySchema"
            @updateTable="updateTable"
            :arrayKey="arrayKey"
            :top="{add: true}"
          />
          <!-- </div>
            </div></div></div>
          </transition> -->
        </div>
        </v-container>
      </v-card-text>

      
    </v-card>
        </v-flex>
 
    <v-flex v-if="arrayEditTable" :xs12="!secondDialogEnabled" :xs7="secondDialogEnabled">
    <div v-if="arrayEditTable" :xs12="!secondDialogEnabled" :xs7="secondDialogEnabled">
      <array-table-editor />
    </div>
    </v-flex>
        </v-layout>
        <v-layout column v-if="secondDialogEnabled">
   <v-flex v-if="secondDialogEnabled" xs5 class="d-flex align-start" flex-direction="column">
      <component :is="secondDialogComponent"> </component>
    </v-flex>
        </v-layout>
        
      </v-layout>
    </v-container>
  <!-- </div> -->
</template>

<script>
import { sync } from 'vuex-pathify'
import utils from '../helpers/utils'
import moment from 'moment'
import singleDND from '../library/SingleDND'
// import CodeEditor from '@/library/CodeEditor'
import ReadOnlyItems from '../library/ReadOnlyItems'
import Measure from '../library/Measure'
import AutoListObjects from '../library/AutoListObjects'
import BuildCallbacks from '@/mixins/buildCallbacks.js'
// import GenericTable from '@/library/GenericTable'

export default {
  name: 'generic-dialog',
  components: {
    singleDND,
    // CodeEditor,
    ReadOnlyItems,
    Measure,
    AutoListObjects,
    // GenericTable
  },
  mixins: [
    BuildCallbacks
  ],
  //props: ['dialogTitle', 'item', 'editIndex', "headers", "editables", "table", 'errorObj', 'tempValue'],
  props: {
    dialogTitle: {
      type: String,
      required: false,
      default: false
    },
    item: {
      type: Object,
      required: false,
      default() {
        return {}
      }
    },
    editIndex: {
      type: Number,
      required: false,
      default: -1
    },
    headers: {
      type: Array,
      required: false,
      default(){
        return []
      }
    },
    editables: {
      type: Array,
      required: false,
      default(){
        return []
      }
    },
    table: {
      type: String,
      required: false,
      default: null
    },
    errorObj: {
      type: Object,
      required: false,
      default(){
        return {}
      }
    }
  },
  data: () => ({
    editedItem:{},
    arrayKey: null,
    arrayRows: [],
    arrayHeaders: [],
    arrayEditables: [],
    arrayTitle: '',
    arraySchema: '',
    isArray: false,
    // arrayProps: {},
    asearch: {},
    tableStateSaved: false,
    showForm: false,
    computeItem: {qty:0, unit: 'lb'},
    show: false,
    modalpicker: null,
    name: '',
    picker: '',
    remote: false,
    measure: false,
    rfid: false,
    remoteDevID: '',
    remoteArgs: '',
    focusedItem: {},
    subtopic: '',
    dialogFooter: true
    // datepickerTooltip: 'Click on the date to open editor'
  }),
  watch: {
    editedItem: {
      deep: true,
      handler (val) {
         //console.log('Edited Item: ', val)
      }
    },
    show (val) {
      if (val == false) this.close()
    },
    dialog (val) {
      if (val == true) {
        this.prepDialog()
      }
    },
    // $ (val) {
    //   console.log ('$v changed: ', val)
    // },
    rfid (val) {
      if (val == false && this.subtopic) {
        this.mqttClient.unsubscribe(this.subtopic)
        this.subtopic == null
      }
    },
    measure (val) {
      if (val == false && this.subtopic) {
        this.mqttClient.unsubscribe(this.subtopic)
        this.subtopic == null
      }
    },
    item(val) {
      this.prepDialog()
    },
    // editedItem : {
    //   handler(val) {
    //     console.log('emitting update', val)
    //     this.$emit('update:tempValue', val)
    //   },
    //   deep: true
    // }
  },
  computed: {
    value () { return this.prop },
    readOnlyItems () {
      return this.editables.filter(i => i.readonly).length
    },
    dark: sync('dark'),
    arrayEditSelector: sync('arrayEditSelector'),
    arrayEditTable: sync('arrayEditTable'),
    dialog: sync('dialogOpen'),
    defaultItem: sync('dialogDefaultItem'),
    user: sync('login/loggedinUser'),
    origUser: sync('login/origLoggedinUser'),
    mqttClient: sync('mqtt/mqttClient'),
    origMqttClient: sync('mqtt/origMqttClient'),
    dialogFunctions: sync('dialogFunctions'),
    inputDevices: sync('inputDevices'),
    secondDialogEnabled: sync('secondDialogEnabled'),
    secondDialogComponent: sync('secondDialogComponent'),
  },
  filters: {
    cellFilter: utils.cellFilter
  },
  methods: {
    log(message){
      console.log(message)
    },
    DNDFileCallback(rec, name, file) {
      console.log(file, rec, name)
      rec[name] = file['name']
    },
    updateTable (val, key) {
      this.editedItem[key] = val
      this.arrayRows=val
    },
    formatItem (item) {
      console.log(item)
      return utils.formatItem(item)
    },
    prepDialog () {
      this.editedItem = {}
      console.log(`Dialog Editables = `)
      console.log(this.editables)
      console.log(`Item = `)
      console.log(this.item)
      let tempItem = Object.assign({}, this.item)
      console.log(`Temp Item = `)
      console.log(tempItem)
      var self = this
      this.editables.forEach(function (item) {
        if (item.name === 'octs') {
          if (!self.item.octs) tempItem.octs = null // Date.now()
        } else if (item.datetimepicker) {
          if (self.item[item.name] != null) {
            tempItem[item.name] = moment(self.item[item.name]).format('llll')
          } else {
            tempItem[item.name] = null
          }
        } else if (item.measure) {
          if (self.editIndex == -1 || self.item[item.name] == null) {
            tempItem[item.name] = {'qty': 0, 'unit': item.units[0]}
          } else {
            tempItem[item.name] = self.item[item.name]
          }
        } else {
          if (self.editIndex == -1) {
            tempItem[item.name] = ''
          } else {
            tempItem[item.name] = self.item[item.name]
          }
        }
      })
      //console.log('Source Item: ', this.editables)
      //console.log('Temp Item After Init: ', tempItem)
      this.editedItem = tempItem
    },
    dialogMeasure(item) {
      var pubtopic = this.user.org + '/request/' + this.remoteDevID
      this.subtopic = this.user.org + '/bcast/' + this.remoteDevID
      this.mqttClient.publish(pubtopic, this.remoteArgs === 'user' ? '{"read_weight":"user"}' : '{"read_weight":"now"}')
      this.mqttClient.subscribe(this.subtopic, function (err) {
        if (err) console.log('mqtt subscribe error: ', err)
      })
      var self = this
      this.mqttClient.on('message', function (topic, message, packet) {
        console.log('message received: ', message.toString())
        if (topic !== self.subtopic) return
        try {
          var resp = JSON.parse(message.toString())
        } catch (ex) {
          console.log('parse exception: ', message.toString(), ex)
        }
        if (self.editedItem !== undefined && resp[0].data !== undefined) {
          self.editedItem[self.measurefield]['qty'] = resp[0]['data']['weight']
          self.editedItem[self.measurefield]['unit'] = resp[0]['data']['unit']
          self.mqttClient.publish(pubtopic, '{"audio": "success"}')
          self.measure = false
        }
      })
      setTimeout(function () {
        if (self.measure) {
          self.mqttClient.publish(pubtopic, '{"audio": "failure"}')
          self.measure = false
        }
      }, self.remoteArgs === 'user' ? 30000 : 10000)
    },
    dialogRemote (item) {
      var pubtopic = this.origUser.org + '/scanreq/' + this.origUser.uid + '/0'
      var subtopic2 = this.origUser.org + '/scanresp/' + this.origUser.uid + '/0'
      this.origMqttClient.publish(pubtopic, '{"msg": "scan now"}')
      console.log('pub, sub: ', pubtopic, subtopic2)
      var self = this
      this.origMqttClient.subscribe(subtopic2, function (err) {
        if (err) console.log('mqtt subscribe error: ', err)
      })
      this.origMqttClient.on('message', function (topic, message, packet) {
        if (topic !== subtopic2) return
        // console.log('RFID message received: topic: %s, message: %message', topic, message)
        try {
          var resp = JSON.parse(message.toString())
        } catch (ex) {
          console.log('parse exception: ', message.toString(), ex)
        }
        
        if (resp.status && resp.status === 'cancelled)') {
          self.remote = false
          // self.mqttClient.unsubscribe(topic)
          return
        }
        if (resp.code !== undefined) {
          self.editedItem[self.remotefield] = resp.code
          self.origMqttClient.unsubscribe(topic)
          self.remote = false
        }
      })
    },
    dialogRFID (item) {
      this.subtopic = this.user.org + '/bcast/' + this.remoteDevID
      var self = this
      this.mqttClient.subscribe(this.subtopic, function (err) {
        if (err) console.log('mqtt subscribe error: ', err)
      })
      this.mqttClient.on('message', function (topic, message, packet) {
        if (topic !== self.subtopic) return
        try {
          var resp = JSON.parse(message.toString())
        } catch (ex) {
          this.elog('error', 'parse exception: {} {}', message.toString(), ex)()
        }
        
        if (resp && resp[0] && resp[0].data && resp[0].data.rfid !== undefined) {
          self.editedItem[self.rfidfield] = resp[0].data.rfid
          self.rfid = false
        }
      })
    },
    cancel(event) {
      this.$emit('returnValue', null)
    },
    async save (event) {
      this.remote = false
      var self = this
      console.log('edited item: ', this.editedItem)
      this.editables.forEach(function (item) {
        if (item.datetimepicker) {
          // console.log('**item: ', item, self.editedItem[item.name])
            self.editedItem[item.name] = self.editedItem[item.name] == null ? null : moment(self.editedItem[item.name]).format()
        }
      })
      let cb = this.table + '_save_callback'
      //console.log('**** save callback: ', cb)
      if (this[cb] == undefined) {
        this.$emit('returnValue', this.editedItem)
        //console.log('saving:::: ', this.editedItem)
        //console.log('Array Values: ', this.arrayEditTable)
        return
      }
      let ret = await this[cb](this.editedItem)
      if (ret == 'stop') {
        return
      } else if (ret == 'continue') {
        console.log('item from table: ', this.editedItem, this.table)
        this.$emit('returnValue', this.editedItem) //just close
      } else {
        console.log('save check returned: ', ret)
        this.$root
        .$confirm("Error", ret, {
          color: "red", nocancel: true, ok: 'OK'
        })
        .then(async function (confirm) {
          return
        });
        console.log('rejecting edit')
        return
      }
    },
    onBlur() {
      this.isArray = false
    },
    onFocus (item) {
       console.log(JSON.stringify(item), this.editedItem)
      this.remote = false
      this.measure = false
      this.focusedItem = item
      this.isArray = false
      var res = this.editables.filter(obj => obj.name === item.name)
       console.log('----', res)
      this.remote = false
      this.remote = (res[0] && res[0].remote) || false
      if (this.remote) this.remotefield = res[0].name
      if (this.inputDevices) {
        let remoteDevPresent = this.inputDevices.filter(i => i.field === item.name)
        this.remoteDevID = ''
        if (remoteDevPresent.length == 1) {
          this.remoteDevID = remoteDevPresent[0].deviceid
          this.remoteArgs = remoteDevPresent[0].args
        } 
        this.rfid = (res[0] && res[0].remote && remoteDevPresent[0] && remoteDevPresent[0].type == 'rfid' && this.remoteDevID !== '') || false
        this.measure = (res[0] && res[0].measure && remoteDevPresent[0] && remoteDevPresent[0].type == 'scale' && this.remoteDevID !== '') || false
        
        if (this.measure) this.measurefield = res[0].name
        if (this.rfid) this.rfidfield = res[0].name
      }
      if (res.length > 0 && res[0].array) {
        this.arrayTitle = item.header.replace("<br>"," ")
        this.arrayKey = item.name
        if (!this.editedItem[item.name]) this.arrayRows=[]
        else this.arrayRows = this.editedItem[item.name]
        this.arrayHeaders = item.headerTable
        console.log('++++', this.arrayHeaders, this.arrayRows)
        this.arrayEditables = item.headerTable.editables
        this.arraySchema = item.arrayTable
        this.isArray = !this.array
      } else {
        this.isArray = false
      }
    },
    // onSelect (k) {
    //   if (this.dialogFunctions.selectItem) {
    //     console.log('main onselect',k,this.editedItem)
    //     this.dialogFunctions.selectItem(k, this.editedItem)
    //   }
    // },
    // onselect (k) {
    //   if (this.dialogFunctions.selectItem) {
    //     console.log('main onselect',k,this.editedItem)
    //     this.dialogFunctions.selectItem(k, this.editedItem)
    //   }
    // }
  },
  created () {
  },
  mounted () {
    this.prepDialog()
    if (this.dialogFunctions.init) this.dialogFunctions.init(this.editedItem)
  },
  beforeDestroy () {
    if (this.subtopic) this.mqttClient.unsubscribe(this.subtopic)
  }
}
</script>

<style >

#measure-div {
  border: 1px gray solid;
  margin: 3px;
}
.measure-elem {
  padding: 3px;
}
.datepicker-header {
  font-size: 90%;
}

.error--text .v-messages__message{
  margin-top: 3px;
}
.generic {
  height: 100%;
}
/* >>>.v-list__group__header__prepend-icon .v-icon {
    color: green;
} */
.modal-mask {
  z-index: 5;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  transition: opacity 0.3s ease;
}

.modal-container {
  border-radius: 2px;
  transition: all 0.3s ease;
  font-family: Helvetica, Arial, sans-serif;
}
.v-dialog {
  height: 90%;
  width: 90%;
  box-shadow: none;
  /* overflow-y: auto !important; */
}
</style>
